// @flow

import { v4 } from 'uuid';
import React from 'react';
import type { Node } from 'react';
import { article as ENUM_ARTICLE } from 'Enum';
import { Button } from '@riseart/common';
import { META_SUBSCRIBER_NAME } from 'shared_services/riseart/meta/Meta';
import { CommonCategoryPage } from 'shared_components/pages/common/Category';
import { Boxes, boxActiveCls } from 'shared_components/common/boxes/Boxes';
import { UrlAssembler } from 'shared_services/riseart/utils/UrlAssembler';

type Props = { staticContext: ?Object };

const PRELOADER_READ_CATEGORY_ID = v4();

/**
 * BlogCategoryPage
 * @returns
 */
export default function BlogCategoryPage({ staticContext }: Props): Node {
  return (
    <CommonCategoryPage
      staticContext={staticContext}
      mainQueryPreloaderId={PRELOADER_READ_CATEGORY_ID}
      articleType={ENUM_ARTICLE.type.TYPE_GUIDE}
      showDate={false}
      listTitleTranslationKey="components.breadcrumbs.guides"
      listUrl={UrlAssembler.guideList()}
      translationPrefix="guideCategory"
      metaSubscriber={META_SUBSCRIBER_NAME.GUIDE_CATEGORY_META}
      customHeaderMenu={(categories, selectedCategoryId) =>
        categories ? (
          <Boxes>
            {categories.map(({ id, uri, type, name }) => {
              const isSelected = selectedCategoryId === id;
              return (
                <Button
                  key={id}
                  className={isSelected ? boxActiveCls : null}
                  type="secondary"
                  isAnchor={!isSelected}
                  to={!isSelected ? UrlAssembler.articleCategory(uri, type) : null}
                >
                  {name}
                </Button>
              );
            })}
          </Boxes>
        ) : null
      }
    />
  );
}
